module.exports = __webpack_public_path__ + "img/note.100935c0.svg";